import {generateUUID4} from '@telstra-connect/utils/data/random'
import global from '@applications/index'

let sessionId: string

export const createSessionId = (): void => {
  sessionId = generateUUID4()
}

export const getSessionId = () => {
  try {
    const {sessionId: sessionIdGlobal} = global.TCONN.getSessionDetails()
    return sessionIdGlobal
  } catch (err) {
    return sessionId
  }
}
